// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/financial/financial_types.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/financial/financial_types.proto.
 */
export const file_proto_model_financial_financial_types = /*@__PURE__*/
  fileDesc("Citwcm90by9tb2RlbC9maW5hbmNpYWwvZmluYW5jaWFsX3R5cGVzLnByb3RvEgZjYXJtZW4qgQMKB1RheFR5cGUSGAoUVEFYX1RZUEVfVU5TUEVDSUZJRUQQABIQCgxUQVhfVFlQRV9WQVQQARIYChRUQVhfVFlQRV9WQVRfUkVEVUNFRBACEhUKEVRBWF9UWVBFX1ZBVF9aRVJPEAMSFgoSVEFYX1RZUEVfU0FMRVNfVEFYEAQSFgoSVEFYX1RZUEVfTE9DQUxfVEFYEAUSFAoQVEFYX1RZUEVfVVNFX1RBWBAGEhAKDFRBWF9UWVBFX0dTVBAHEhAKDFRBWF9UWVBFX0hTVBAIEhAKDFRBWF9UWVBFX1BTVBAJEhUKEVRBWF9UWVBFX0NJVFlfVEFYEAoSGgoWVEFYX1RZUEVfT0NDVVBBTkNZX1RBWBALEhgKFFRBWF9UWVBFX1RPVVJJU1RfVEFYEAwSFwoTVEFYX1RZUEVfRVhDSVNFX1RBWBANEhwKGFRBWF9UWVBFX1dJVEhIT0xESU5HX1RBWBAOEhkKFVRBWF9UWVBFX0NVU1RPTVNfRFVUWRAPKrsBCgtUYXhSYXRlVHlwZRIdChlUQVhfUkFURV9UWVBFX1VOU1BFQ0lGSUVEEAASHAoYVEFYX1JBVEVfVFlQRV9QRVJDRU5UQUdFEAESGgoWVEFYX1JBVEVfVFlQRV9GTEFUX0ZFRRACEhgKFFRBWF9SQVRFX1RZUEVfVElFUkVEEAMSHAoYVEFYX1JBVEVfVFlQRV9QRVJfUEVSU09OEAQSGwoXVEFYX1JBVEVfVFlQRV9QRVJfTklHSFQQBSrIAwoQVGF4RXhlbXB0aW9uVHlwZRIiCh5UQVhfRVhFTVBUSU9OX1RZUEVfVU5TUEVDSUZJRUQQABInCiNUQVhfRVhFTVBUSU9OX1RZUEVfQlVTSU5FU1NfUFVSUE9TRRABEh0KGVRBWF9FWEVNUFRJT05fVFlQRV9SRVNBTEUQAhIdChlUQVhfRVhFTVBUSU9OX1RZUEVfRVhQT1JUEAMSIQodVEFYX0VYRU1QVElPTl9UWVBFX0RJUExPTUFUSUMQBBIhCh1UQVhfRVhFTVBUSU9OX1RZUEVfR09WRVJOTUVOVBAFEh8KG1RBWF9FWEVNUFRJT05fVFlQRV9NSUxJVEFSWRAGEiAKHFRBWF9FWEVNUFRJT05fVFlQRV9OT05QUk9GSVQQBxIeChpUQVhfRVhFTVBUSU9OX1RZUEVfQ0hBUklUWRAIEiAKHFRBWF9FWEVNUFRJT05fVFlQRV9SRUxJR0lPVVMQCRIfChtUQVhfRVhFTVBUSU9OX1RZUEVfUkVTSURFTlQQChIeChpUQVhfRVhFTVBUSU9OX1RZUEVfU1RVREVOVBALEh0KGVRBWF9FWEVNUFRJT05fVFlQRV9TRU5JT1IQDEI4Qg5GaW5hbmNpYWxUeXBlc1omZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw");

/**
 * Describes the enum carmen.TaxType.
 */
export const TaxTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_financial_financial_types, 0);

/**
 * Types of taxes supported across different jurisdictions
 *
 * @generated from enum carmen.TaxType
 */
export const TaxType = /*@__PURE__*/
  tsEnum(TaxTypeSchema);

/**
 * Describes the enum carmen.TaxRateType.
 */
export const TaxRateTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_financial_financial_types, 1);

/**
 * Tax rate structures for different calculation methods
 *
 * @generated from enum carmen.TaxRateType
 */
export const TaxRateType = /*@__PURE__*/
  tsEnum(TaxRateTypeSchema);

/**
 * Describes the enum carmen.TaxExemptionType.
 */
export const TaxExemptionTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_financial_financial_types, 2);

/**
 * Tax exemption categories for different customer types
 *
 * @generated from enum carmen.TaxExemptionType
 */
export const TaxExemptionType = /*@__PURE__*/
  tsEnum(TaxExemptionTypeSchema);

